"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentsAdvertiserEventsService = void 0;
class DeploymentsAdvertiserEventsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get deployment event information
     * @param id
     * @param q
     * @param page
     * @param count
     * @returns DeploymentAdvertiserEventsResponse
     * @throws ApiError
     */
    getDeploymentAdvertiserEvents(id, q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/events',
            path: {
                'id': id,
            },
            query: {
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
}
exports.DeploymentsAdvertiserEventsService = DeploymentsAdvertiserEventsService;
